
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-professionals/the-update/[...slug]",
      function () {
        return require("private-next-pages/medical-professionals/the-update/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-professionals/the-update/[...slug]"])
      });
    }
  